import { SvgIcon, SvgIconProps } from '@mui/material';

export default function IconInfo({ ...props }: SvgIconProps) {
  return (
    <SvgIcon height="20" viewBox="0 0 20 20" width="20" {...props}>
      <path
        clipRule="evenodd"
        d="M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10ZM18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 8.5H10H10.5V9V13.5H11.5V14.5H8.5V13.5H9.5V9.5H9V8.5Z"
        fill="#202723"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
}
